<dx-box *ngIf="!!community" width="100%" height="100%" direction="col" class="payment-detail-box-container">
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <dx-form
                #workflowAdvanceInvoiceEditor
                *ngIf="!!paymentWorkflow"
                width="100%"
                height="100%"
                labelLocation="top"
                class="advanced-payment-form"
                [colCount]="1"
            >
                <dxi-item itemType="group" [colCount]="2">
                    <dxi-item [isRequired]="true">
                        <dxo-label text="Invoice / Receipt Date"></dxo-label>
                        <div *dxTemplate>
                            <div class="row-container">
                                <dx-date-box
                                    type="date"
                                    [openOnFieldClick]="true"
                                    [elementAttr]="{ class: 'field-component' }"
                                    [(value)]="paymentWorkflow.invoiceDate"
                                    (onValueChanged)="onInvoiceDateChanged()"
                                ></dx-date-box>
                                <div class="row-content" id="invoiceDateInfo">
                                    <i
                                        class="cc-1-5x icon-label-content dx-theme-accent-as-text-color"
                                        [ngClass]="iconInfo"
                                        (mouseenter)="onInvoiceDateInfoClick()"
                                    ></i>
                                    <dx-popover
                                        target="#invoiceDateInfo"
                                        position="top"
                                        [height]="50"
                                        [width]="250"
                                        [(visible)]="showInvoiceDateInfo"
                                    >
                                        <div *dxTemplate="let data of 'content'">
                                            What is the Invoice / Receipt Date? (only if available on the documentation)
                                        </div>
                                    </dx-popover>
                                </div>
                            </div>
                        </div>
                    </dxi-item>
                    <dxi-item [isRequired]="true">
                        <dxo-label text="Invoice Number#"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box
                                #invoiceNumber
                                [elementAttr]="{ class: 'field-component' }"
                                [(value)]="paymentWorkflow.invoiceNumber"
                            ></dx-text-box>
                        </div>
                    </dxi-item>
                </dxi-item>

                <dxi-item itemType="group" [colCount]="2">
                    <dxi-item [isRequired]="true">
                        <dxo-label text="Bank Account"></dxo-label>
                        <div *dxTemplate>
                            <app-multi-column-selector
                                #bankAccountSelector
                                [name]="'Bank Account'"
                                [cssClass]="'field-component'"
                                [gridSource]="bankAccountSource"
                                [boxValue]="bankAccountBoxValue"
                                [valueExpr]="'bankAccountId'"
                                [displayExpr]="'accountName'"
                                [columnDef]="bankAccountColumns"
                                [dropDownButtonTemplate]="'dropDownButton'"
                                [dropDownOptions]="{ width: 'auto' }"
                                [showClearButton]="true"
                                [placeholder]="'Select Bank Account...'"
                                (gridSelectionEvent)="onBankAccountSelection($event)"
                            ></app-multi-column-selector>
                        </div>
                    </dxi-item>
                    <dxi-item [isRequired]="true">
                        <dxo-label text="Total Amount"></dxo-label>
                        <div *dxTemplate>
                            <dx-number-box
                                [elementAttr]="{ class: 'field-component' }"
                                [showClearButton]="true"
                                [showSpinButtons]="false"
                                [format]="currencyFormat"
                                [min]="0"
                                [(value)]="paymentWorkflow.invoiceAmount"
                                (onValueChanged)="onInvoiceAmountChanged($event)"
                            ></dx-number-box>
                        </div>
                    </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [colCount]="2">
                    <dxi-item [isRequired]="true">
                        <dxo-label text="Payee"></dxo-label>
                        <div *dxTemplate>
                            <div class="row-container">
                                <dx-text-box
                                    [elementAttr]="{ class: 'field-component' }"
                                    [(value)]="payeeName"
                                    (onKeyDown)="onPayeeClick()"
                                >
                                    <dxi-button
                                        *ngIf="!!payeeName"
                                        name="clearP"
                                        location="after"
                                        [options]="{
                                            stylingMode: 'text',
                                            icon: iconCross,
                                            class: 'dx-theme-accent-as-text-color',
                                            onClick: onPayeeClear
                                        }"
                                    ></dxi-button>
                                    <dxi-button
                                        name="search"
                                        location="after"
                                        [options]="{
                                            type: 'default',
                                            icon: iconEllipsish,
                                            onClick: onPayeeClick
                                        }"
                                    ></dxi-button>
                                </dx-text-box>
                                <div class="row-content">
                                    <i
                                        class="cc-1-5x icon-label-content dx-theme-accent-as-text-color"
                                        [ngClass]="iconHelp"
                                        (click)="onPayeeHelpClick()"
                                    ></i>
                                </div>
                            </div>
                        </div>
                    </dxi-item>
                    <dxi-item itemType="empty" [visible]="!selectedVendor"></dxi-item>
                    <dxi-item [visible]="!!selectedVendor" [isRequired]="isVendorAccountMandatory">
                        <dxo-label text="Vendor Accounts"></dxo-label>
                        <div *dxTemplate>
                            <div class="row-container">
                                <app-multi-column-selector
                                    #vendorAccountSelector
                                    [name]="'Vendor Account'"
                                    [cssClass]="'field-component'"
                                    [gridSource]="payeeInfo?.vendorAccounts"
                                    [boxValue]="vendorAccountBoxValue"
                                    [valueExpr]="'id'"
                                    [displayExpr]="'accountNumber'"
                                    [columnDef]="vendorAccountColumns"
                                    [dropDownButtonTemplate]="vendorAccountDropDownButtonTemplate"
                                    [dropDownOptions]="{ width: 'auto' }"
                                    [showClearButton]="false"
                                    [isItemSelectionMandatory]="true"
                                    [placeholder]="'Select Vendor Account...'"
                                    [disabled]="paymentWorkflow.payeeType !== 'vendor' || !payeeName"
                                    (gridSelectionEvent)="onVendorAccountSelection($event)"
                                    (detailTemplateEvent)="onVendorAccountDetailClick()"
                                    (addTemplateEvent)="onAddVendorAccountClick()"
                                ></app-multi-column-selector>
                                <div *ngIf="!!paymentWorkflow?.vendorAccountId" class="row-content">
                                    <div class="icon-label-content" (click)="onVendorAccountHistoryClick()">
                                        <i
                                            title="Vendor Account History"
                                            class="fa-2x dx-theme-accent-as-text-color"
                                            [ngClass]="iconHistory"
                                        ></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dxi-item>
                    <dxi-item
                        [isRequired]="paymentWorkflow.payeeCode === 'RM_NOTINLIST'"
                        [visible]="paymentWorkflow.payeeCode === 'RM_NOTINLIST'"
                    >
                        <dxo-label text="Vendor Info"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box
                                [elementAttr]="{ class: 'field-component' }"
                                [(value)]="paymentWorkflow.vendorInfo"
                            ></dx-text-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Print As"></dxo-label>
                        <div *dxTemplate>
                            <div class="row-container">
                                <dx-text-box
                                    [disabled]="paymentWorkflow.payeeType !== 'owner'"
                                    [elementAttr]="{ class: 'field-component' }"
                                    [(value)]="paymentWorkflow.printedOwnerName"
                                ></dx-text-box>
                                <div *ngIf="paymentWorkflow.payeeType === 'owner'" class="row-content" id="printAsInfo">
                                    <i
                                        class="fa-lg icon-label-content dx-theme-accent-as-text-color"
                                        [ngClass]="iconInfo"
                                        (mouseenter)="onPrintAsInfoInfoClick()"
                                    ></i>
                                    <dx-popover
                                        target="#printAsInfo"
                                        position="bottom"
                                        [height]="70"
                                        [width]="250"
                                        [(visible)]="showPrintAsInfo"
                                    >
                                        <div *dxTemplate="let data of 'content'">
                                            <div class="text-info-content">
                                                Name that will be printed on Check.
                                                <div class="cc-text-required">
                                                    (NOTE: Name change is permanent and is reflected on all future
                                                    checks)
                                                </div>
                                            </div>
                                        </div>
                                    </dx-popover>
                                </div>
                            </div>
                        </div>
                    </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [colCount]="4">
                    <dxi-item [colSpan]="2">
                        <dxo-label text="Description"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box
                                [disabled]="
                                    !paymentWorkflow.payeeType ||
                                    !paymentWorkflow?.bankAccountId ||
                                    !paymentWorkflow?.invoiceAmount
                                "
                                [elementAttr]="{ class: 'field-component' }"
                                [(value)]="paymentWorkflow.description"
                            ></dx-text-box>
                        </div>
                    </dxi-item>
                    <dxi-item isRequired="true">
                        <dxo-label text="Due Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box
                                type="date"
                                [disabled]="
                                    !paymentWorkflow.payeeType ||
                                    !paymentWorkflow?.bankAccountId ||
                                    !paymentWorkflow?.invoiceAmount
                                "
                                [openOnFieldClick]="true"
                                [elementAttr]="{ class: 'field-component' }"
                                [(value)]="paymentWorkflow.dueDate"
                            ></dx-date-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="EFT Account"></dxo-label>
                        <div *dxTemplate>
                            <dx-switch
                                switchedOnText="Yes"
                                switchedOffText="No"
                                [disabled]="
                                    !paymentWorkflow.payeeType ||
                                    !paymentWorkflow?.bankAccountId ||
                                    !paymentWorkflow?.invoiceAmount ||
                                    isEFTDisabled
                                "
                                [elementAttr]="{ class: 'field-switch-small' }"
                                [(value)]="paymentWorkflow.isEFTAccount"
                            ></dx-switch>
                        </div>
                    </dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </dxi-item>
    <dxi-item [ratio]="1.5">
        <div *dxTemplate>
            <div class="editor-container">
                <app-workflow-payment-request-line-item-editor
                    #lineItemEditor
                    [disabled]="isLineItemEditorDisabled"
                    [invoiceAmount]="paymentWorkflow?.invoiceAmount"
                    [lineItems]="paymentWorkflow?.items"
                    [glAccountsBudgetInfo]="codingEditor?.glAccounts"
                    [dimensionSource]="codingEditor?.dimensions"
                    [managementCompanyId]="community?.managementCompanyId"
                    [communityId]="community?.communityId"
                    [entityUsesSubCategory]="advancePaymentEditor?.entityUsesSubCategory"
                    [defaultLineItems]="defaultLineItems"
                    [allowEditDimension]="codingEditor?.allowEditDimension"
                    [selectedBankAccount]="selectedBankAccount"
                ></app-workflow-payment-request-line-item-editor>
            </div>
        </div>
    </dxi-item>
</dx-box>

<app-workflow-payment-request-payee-selector
    *ngIf="showPayeeSelector"
    [communityId]="community?.communityId"
    (onPayeeSelection)="onPayeeSelection($event)"
    (onClose)="onPayeeSelectorClose($event)"
></app-workflow-payment-request-payee-selector>

<app-workflow-iva-history
    *ngIf="showVendorAccountHistory"
    [communityId]="community?.communityId"
    [payee]="payeeName"
    [mode]="'vendorAccountHistory'"
    [title]="'Vendor Account History'"
    [vendorAccountHistoryBaseParams]="vendorAccountHistoryBaseParams"
    (closeIVAHistory)="onVendorAccountHistoryClose()"
></app-workflow-iva-history>

<app-manage-vendor-accounts
    #manageVendorAccount
    *ngIf="showManageVendorAccountPopup"
    [vendorCode]="selectedVendor?.vendorCode"
    [vendorName]="selectedVendor?.vendorName"
    [associationVendorId]="selectedVendor?.vendorBranchAssociationId"
    [communityId]="community?.communityId"
    [communityName]="community?.communityName"
    (closeManageVendorAccounts)="onManageVendorAccountClose()"
    (onVendorAccountEditorClick)="onVendorAccountSelectionForEditor($event)"
></app-manage-vendor-accounts>

<app-vendor-account-editor
    #vendorAccountEditorConfig
    *ngIf="showAddEditVendorAccount"
    [title]="addEditVendorAccountPopUpTitle"
    [configMode]="vendorAccountConfigMode"
    [communityId]="community?.communityId"
    [vendorName]="selectedVendor?.vendorName"
    [associationVendorId]="selectedVendor?.vendorBranchAssociationId"
    [vendorAccount]="selectedVendorAccountForEditor"
    (closeVendorAccount)="onVendorAccountEditorClose($event)"
></app-vendor-account-editor>

<app-detail-popups [isCorporateCirabook]="isCorporateCirabook"></app-detail-popups>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#workflowAdvanceInvoiceEditor' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
